module.exports = __webpack_public_path__ + "img/house-icon.c9d4aa01.svg";